import {
  create,
  NConfigProvider,
  NMessageProvider,
  NDialogProvider,
  NButton,
  NButtonGroup,
  NInput,
  NInputNumber,
  NForm,
  NFormItem,
  NSelect,
  NCheckbox,
  NTag,
  NScrollbar,
  NDatePicker,
  NSpace,
  NAvatar,
  NCard,
  NEmpty,
  NIcon,
  NTree,
  NTreeSelect,
  NTable,
  NDropdown,
  NPopover,
  NDataTable,
  NSwitch,
  NPagination,
  NDivider,
  NDialog,
  NModal,
} from 'naive-ui'

export function setupNaive(app) {
  const naive = create({
    components: [
      NConfigProvider,
      NMessageProvider,
      NDialogProvider,
      NButton,
      NButtonGroup,
      NInput,
      NInputNumber,
      NForm,
      NFormItem,
      NSelect,
      NCheckbox,
      NTag,
      NScrollbar,
      NDatePicker,
      NSpace,
      NAvatar,
      NCard,
      NEmpty,
      NIcon,
      NTree,
      NTreeSelect,
      NTable,
      NDropdown,
      NPopover,
      NDataTable,
      NSwitch,
      NPagination,
      NDivider,
      NDialog,
      NModal,
    ],
  })
  app.use(naive)
}
